import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const ChevronDown = createIcon({
  displayName: "ChevronDown",
  viewBox: "0 0 24 24",
  defaultProps: {
    role: "img"
  },
  path: (
    <>
      <title> Chevron Down Icon </title>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.14645 8.14645C4.34171 7.95118 4.65829 7.95118 4.85355 8.14645L11.54 14.8329L18.2264 8.14645C18.4217 7.95118 18.7383 7.95118 18.9336 8.14645C19.1288 8.34171 19.1288 8.65829 18.9336 8.85355L11.8936 15.8936C11.7998 15.9873 11.6726 16.04 11.54 16.04C11.4074 16.04 11.2802 15.9873 11.1864 15.8936L4.14645 8.85355C3.95118 8.65829 3.95118 8.34171 4.14645 8.14645Z"
      />
    </>
  )
});
